var map = {
	"./scene10.jpg": "T7H/",
	"./scene11.jpg": "H/x+",
	"./scene12.jpg": "o9DE",
	"./scene9.jpg": "PDRQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z3mI";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/scene.*\.jpg$
// module id = Z3mI
// module chunks = 1